module.exports = __webpack_public_path__ + "img/BannerFilled.ef58e1e9.svg";